define('editor/edit/layers/edit/minimap',['jquery', './layerBase'], function ($, layerBase) {
    var viewmodel = function () {
        var self = this;

        var moduleId = self.__moduleId__;
        $.extend(self, new layerBase());
        self.__moduleId__ = moduleId;
    };

    return viewmodel;
});

